type TranscriptKind = "partial" | "commit" | "final";

let partialCount = 0;
let commitCount = 0;
let maxPartialLength = 0;
let maxCommitLength = 0;

export function resetDictationTranscriptDiagnostics(): void {
  partialCount = 0;
  commitCount = 0;
  maxPartialLength = 0;
  maxCommitLength = 0;
}

export function recordDictationTranscriptDiagnostic(
  kind: TranscriptKind,
  text: string,
  durationMs: number,
): string | null {
  if (kind === "partial") {
    partialCount += 1;
    maxPartialLength = Math.max(maxPartialLength, text.length);
    return null;
  }
  if (kind === "commit") {
    commitCount += 1;
    maxCommitLength = Math.max(maxCommitLength, text.length);
    return null;
  }
  const diagnostic =
    `voice-transcript final length=${text.trim().length}` +
    ` duration_ms=${durationMs}` +
    ` partial_count=${partialCount} commit_count=${commitCount}` +
    ` max_partial_length=${maxPartialLength}` +
    ` max_commit_length=${maxCommitLength}`;
  resetDictationTranscriptDiagnostics();
  return diagnostic;
}
